// Create starts the guided page anew (spec ui-perf/simple-shell, decision 4): its navigation
// carries a fresh stamp in the history state, which keys the page, so a run, a template or a
// product chosen before does not come back. The URL stays the page's own.
import type { HistoryState } from "@tanstack/react-router";

declare module "@tanstack/react-router" {
  interface HistoryState {
    /** The moment Create started the guided page: each start a page of its own. */
    simpleStart?: number;
  }
}

/** The history state of a fresh start: the last navigation's, with a new stamp. */
export function freshStart(previous: HistoryState): HistoryState {
  return { ...previous, simpleStart: Date.now() };
}
